import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import MenuListComposition from './MenuListComposition';
import { toggleExportButton } from '../../../redux/actions/reports-actions';
import { TopMenuContainer } from './styles';

const getUser = () => {
  try {
    const userData = localStorage.getItem('user');
    return JSON.parse(userData);
  } catch (error) {
    console.error('Error reading or parsing user data from local storage', error);
    return null;
  }
};

const hasAccess = (user, types) => {
  const effectiveUser = user || getUser();
  return types.includes(effectiveUser?.majority_type);
};

const createMenuItem = (intl, key, link, additionalProps = {}) => ({
  menuTitle: {
    label: intl.messages[key] || key,
    link,
    ...additionalProps,
  },
});

const TopMenu = ({ intl, user }) => {
  const adminAccess = hasAccess(user, ['sub_admin', 'master']);
  const masterAccess = hasAccess(user, ['master']);

  const dashboards = adminAccess ? {
    menuTitle: {
      label: intl.messages['top_menu.dashboards'] || 'Dashboards',
      type: 'dashboards',
    },
    menuItems: [
      {
        label: intl.messages['top_menu.adherence'] || 'Adherence',
        link: '/dashboard',
      },
      {
        label: intl.messages['top_menu.quality'] || 'Quality',
        link: '/dashboard/quality',
      },
    ],
  } : {
    menuTitle: {
      label: intl.messages['top_menu.adherence'] || 'Adherence',
      link: '/dashboard',
    },
  };

  return (
    <TopMenuContainer>
      <MenuListComposition
        menuTitle={dashboards.menuTitle}
        menuItems={dashboards.menuItems}
      />
      {masterAccess && (
        <>
          <MenuListComposition menuTitle={createMenuItem(intl, 'top_menu.forms', '/forms').menuTitle} />
          <MenuListComposition menuTitle={createMenuItem(intl, 'user_settings.routines', '/routines').menuTitle} />
        </>
      )}
      <MenuListComposition menuTitle={createMenuItem(intl, 'top_menu.reminders', '/app_user/reminders', { type: 'app_user_reminder' }).menuTitle} />
      <MenuListComposition menuTitle={createMenuItem(intl, 'top_menu.reports', '/reports/reminders', { type: 'reports' }).menuTitle} />
      <MenuListComposition menuTitle={createMenuItem(intl, 'top_menu.action_plan', '/action-plan').menuTitle} />
      <MenuListComposition menuTitle={createMenuItem(intl, 'top_menu.power_bi', '/power-bi').menuTitle} />
    </TopMenuContainer>
  );
};

TopMenu.propTypes = {
  intl: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    majority_type: PropTypes.string,
  }),
};

const mapStateToProps = state => ({
  user: state.login.information,
});

const mapDispatchToProps = dispatch => ({
  handleButtonClick: () => dispatch(toggleExportButton()),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TopMenu));
